// extracted by css-extract-rspack-plugin
export default {"EmbedPreviewIframe":"GDukK"};